/**
 * Creates a promise that resolves after the specified duration
 * @param {number} duration - The duration to wait in milliseconds
 * @returns {Promise<void>} A promise that resolves after the specified duration
 */
export const wait = (duration: number) => new Promise((resolve) => setTimeout(resolve, duration));
